export const fetch_user_bookings_api = "eud/transactions/list";
export const fetch_all_user_booking_types_api =
  "payments/booked/listings/type/list";
export const fetch_top_engaged_booking_api =
  "host/customer/last/offering/activity/get";
export const fetch_booking_details = "eud/transactions/detail";
